export default "__VITE_ASSET__BPHVCurf__$_?url__"